<template>
    <div class="table-pagination">
        <div class="pull-left" style="width:210px;margin-bottom: 10px;">
            {{ __('show') }}
            <div style="display:inline-block">
                <select class="form-control per-page" @change="perPageChange">
                    <option v-for="option in per_page_options" :value="option"
                            :selected="perPage === option"
                    >{{ option }}</option>
                </select>
            </div>
            <span v-if="meta">
                {{ __('records') }} {{ __('out_of') }} {{ total }}
            </span>
        </div>

        <div class="pull-right" v-if="meta">
            <div class="btn-group">
                <button class="btn btn-white btn-xs btn-pagination" :disabled="!hasPrevPage()">
                    <a @click="first">&lt;&lt; {{ __('first') }}</a>
                </button>
                <button class="btn btn-white btn-xs btn-pagination" :disabled="!hasPrevPage()">
                    <a @click="prev">&lt; {{ __('prev') }}</a>
                </button>
            </div>
            <div class="btn-group pagination-buttons">
                <div class="input-group">
                    <label class="fw-400">{{ __('page') }}:&nbsp</label>
                    <input type="text" name="page" class="page-input form-control " :value="currentPage"
                           style="height: 20px; width: 40px; font-size: 12px; padding: 0px 3px; text-align: center; border-radius: 3px;">
                    <input type="submit" style="display:none"/>
                    &nbsp{{ __('out_of') }}&nbsp{{ lastPage }}
                </div>
            </div>
            <div class="btn-group">
                <button class="btn btn-white btn-xs btn-pagination" :disabled="!hasNextPage()">
                    <a @click="next">{{ __('next') }} &gt;</a>
                </button>
                <button class="btn btn-white btn-xs btn-pagination" :disabled="!hasNextPage()">
                    <a @click="last">{{ __('last') }} &gt;&gt;</a>
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data: function() {
            return {
                per_page_options: [ '25', '50', '100', '250', '500', '1000', $.i18n._('all')]
            }
        },
        methods: {
            perPageChange: function() {
                const select = event.target;
                const per_page = select.options[select.selectedIndex].value;
                this.$emit('paginate:per-page', per_page)
            },
            next: function() {
                this.$emit('paginate:page', this.currentPage + 1)
            },
            prev: function () {
                this.$emit('paginate:page', this.currentPage - 1)
            },
            last: function() {
                this.$emit('paginate:page', this.lastPage)
            },
            first: function() {
                this.$emit('paginate:page', 1)
            },
            hasNextPage: function() {
                return this.lastPage !== this.currentPage && ![this.lastPage,this.currentPage].includes(0)
            },
            hasPrevPage: function() {
                return this.currentPage !== 1 && this.currentPage !== 0
            }
        },
        computed: {
            perPage: function() { return this.meta && this.meta.hasOwnProperty('per_page') ? this.meta.per_page : $.i18n._('all');  },
            currentPage: function() { return this.meta && this.meta.hasOwnProperty('current_page') ? this.meta.current_page : 0; },
            lastPage: function() {  return this.meta && this.meta.hasOwnProperty('last_page') ? this.meta.last_page : 0; },
            total: function() {  return this.meta && this.meta.hasOwnProperty('total') ? this.meta.total : 0; }
        },
        props: [ 'meta' ] // 'current_page', 'last_page', 'per_page', 'total'

    }
</script>

<style>
    .pagination-buttons {
        display:inline-block;
        font-size: 12px;
        margin-top: 0px;
    }
    .fw-400 {
        font-weight: 400 !important;
    }
</style>
